var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, keyframes } from '@emotion/core';
var fade = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
export var fadeOut = _ref => {
  var fadeDuration = _ref.fadeDuration;
  return /*#__PURE__*/css("animation:", fade, " ", fadeDuration, "ms ease-in normal forwards;");
};
export var fadeIn = _ref2 => {
  var fadeDuration = _ref2.fadeDuration,
    crossover = _ref2.crossover;
  return /*#__PURE__*/css("animation:", fade, " ", fadeDuration, "ms ease-in ", fadeDuration * (1 - crossover), "ms reverse backwards;");
};
export var child = {
  name: "f1m332",
  styles: "position:absolute;display:block;width:100%;"
};
export var nextChild = {
  name: "7wh13m",
  styles: "display:block;width:100%;"
};
export var container = {
  name: "q20pgy",
  styles: "position:relative;display:flex;flex-direction:row;align-items:center;"
};
export var single = {
  name: "13o7eu2",
  styles: "display:block;"
};